import { configureStore, createSlice } from '@reduxjs/toolkit'

let user = createSlice({
    name : 'user',
    initialState : { name : 'User', age : "" },
    reducers :{
    changeName(state){
        state.name = 'park'
    }
    }
  })
  

export let { changeName } = user.actions;

let cart = createSlice({
    name : 'cart',
    initialState : [
      {id : 10, name : 'Organic Fruitsk', count : 1},
      {id : 11, name : 'Summer Fruits', count : 1}
    ],
    reducers : {
        addCount(state, action){
           let num = state.findIndex((a)=>{ return a.id === action.payload })          
           state[num].count++
        },
        addCount2(state, action){
            let num = state.findIndex((a)=>{return a.id === action.payload})
            state[num].count--;
            if(state[num].count < 0){
              alert("0보다 작을 수 없습니다");
              state[num].count=0;
            }
        },
        addItem(state, action){
            state.push(action.payload)
        },
        sortName(state, action) {
          state.sort((a, b) => 
            a.name > b.name ? 1 : -1,
          );
       }      
    }
  })

  export let { addCount, addItem, sortName, addCount2 } = cart.actions



  let numb = createSlice({
    name: 'numb',
    initialState: {num:1},
    reducers: {
      increase(state,action){
        state.num +=action.payload;
      },
      decrease(state,action){
        state.num -=action.payload;
        if(state.num < 0){
            alert("0보다 작아질 수 없습니다.");
            state.num=0;
        }
      }
    }
  })

  export let { increase, decrease } = numb.actions


 export default configureStore({
    reducer: {
      user : user.reducer,
      cart : cart.reducer,
      numb : numb.reducer
    }
  }) 